import { FC } from 'react';
import { TitleStyled } from './style';

const Title: FC = ({ children, ...restProps }) => <TitleStyled {...restProps}>{children}</TitleStyled>;

export default Title;
